import {
    LOAD_DEFAULT_PPI_WEIGHTS,
    CHANGE_PPI_TABLE_ITEM,
    PPI_TABLE,
    ADD_PPI_TABLE_ROW,
    DELETE_PPI_TABLE_ROW,
    LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST
} from './constants';
import { POST } from '../constants';
// import { SET, DELETE, POST, GENERATE, START, SUCCESS, FAIL } from '../constants';

const ppiDefault = {
    playersWeights: {
        goalkeeper: {},
        forward: {},
        defender: {},
        midfielder: {}
    },
    typePlayersList: ['goalkeeper', 'defender', 'midfielder', 'forward'],
    // tableRows: {
    //     in_line_up: {
    //         title: 'I startopstillingen',
    //         label: 'in_line_up'
    //     },
    //     subbed_in: {
    //         title: 'Indskiftet',
    //         label: 'subbed_in'
    //     },
    //     clean_sheet: {
    //         title: 'Rent Bur',
    //         label: 'clean_sheet'
    //     },
    //     goal_assists: {
    //         title: 'Assist',
    //         label: 'goal_assists'
    //     },
    //     goals: {
    //         title: 'Mål',
    //         label: 'goals'
    //     },
    //     saved_penalty: {
    //         title: 'Reddet straffe',
    //         label: 'saved_penalty'
    //     },
    //     saves: {
    //         title: 'Redning',
    //         label: 'saves'
    //     },
    //     total_tackle: {
    //         title: 'Nøgletackling',
    //         label: 'total_tackle'
    //     },
    //     blocked_pass: {
    //         title: 'Blokeringer',
    //         label: 'blocked_pass'
    //     },
    //     total_clearance: {
    //         title: 'Clearinger',
    //         label: 'total_clearance'
    //     },
    //     duel_won: {
    //         title: 'Vundne bolde',
    //         label: 'duel_won'
    //     },
    //     total_scoring: {
    //         title: 'Skud på mål',
    //         label: 'total_scoring'
    //     },
    //     missed_penalty: {
    //         title: 'Brændt straffespark',
    //         label: 'missed_penalty'
    //     },
    //     yellow_card: {
    //         title: 'Gult kort',
    //         label: 'yellow_card'
    //     },
    //     red_card: {
    //         title: 'Rødt kort',
    //         label: 'red_card'
    //     },
    //     own_goals: {
    //         title: 'Selvmål',
    //         label: 'own_goals'
    //     },
    //     /////
    //     punches: {
    //         title: 'Punches',
    //         label: 'punches'
    //         // typePlayer: ''
    //     },
    //     att_freekick_goal: {
    //         title: 'Mål scoret på frispark',
    //         label: 'att_freekick_goal'
    //     }
    // },
    tableRowList: [
        'home_win',
        'away_win',
        'draw',
        'loosing_home',
        'loosing_away',
        'goals_against',
        'minimum_goal_victory',
        //
        'in_line_up',
        'subbed_in',
        'clean_sheet',
        'goal_assists',
        'goals',
        'saved_penalty',
        'saves',
        'total_tackle',
        'blocked_pass',
        'total_clearance',
        'duel_won',
        'total_scoring',
        'missed_penalty',
        'yellow_card',
        'red_card',
        'own_goals',
        //
        'punches',
        'att_freekick_goal'
    ],
    tableRowVisibleList: []
};

export default (ppi = ppiDefault, { type, payload }) => {
    switch (type) {
        case POST + PPI_TABLE:
            console.log(JSON.stringify(ppi.playersWeights), '\n----- JSON.stringify(playersWeights) ----');
            return ppi;
        case LOAD_DEFAULT_PPI_WEIGHTS:
            return { ...ppi, playersWeights: payload.playersWeights };
        case LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST:
            return { ...ppi, tableRowVisibleList: payload.list };
        case ADD_PPI_TABLE_ROW: {
            if (!ppi.tableRowVisibleList.includes(payload.labelRow)) {
                return {
                    ...ppi,
                    tableRowVisibleList: [...ppi.tableRowVisibleList, payload.labelRow]
                };
            }

            return ppi;
        }
        case DELETE_PPI_TABLE_ROW: {
            const playersWeights = { ...ppi.playersWeights };

            ppi.typePlayersList.forEach(pl => {
                if (playersWeights[pl]) {
                    playersWeights[pl] = { ...ppi.playersWeights[pl] };
                    delete playersWeights[pl][payload.labelRow];
                }
            });

            return {
                ...ppi,
                playersWeights,
                tableRowVisibleList: [...ppi.tableRowVisibleList.filter(row => row !== payload.labelRow)]
            };
        }
        case CHANGE_PPI_TABLE_ITEM:
            return {
                ...ppi,
                playersWeights: {
                    ...ppi.playersWeights,
                    [payload.typePlayer]: {
                        ...ppi.playersWeights[payload.typePlayer],
                        [payload.label]: payload.value
                    }
                }
            };
        default:
            return ppi;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/reducer.js
 **/